import { useEffect } from 'react';
import { useActivatePlugin } from '../services/useActivatePlugin';
import styles from './ActivatePluginButton.module.css';
import AnimatedLoader from 'components/shared/status/AnimatedLoader';

const ActivatePluginButton = ({ children, id, onSuccess }) => {
    const { response, loading, activatePlugin, resetServerStatus } = useActivatePlugin();

    useEffect(() => {
        if (response?.status) {
            resetServerStatus();
            if (onSuccess) {
                onSuccess();
            }
        }
    }, [response, onSuccess, resetServerStatus]);

    if (loading) {
        return (
            <AnimatedLoader />
        )
    }
    return (
        <button onClick={() => activatePlugin({ id })} className={styles.activate_plugin_btn}>
            {children}
        </button>
    )
}

export default ActivatePluginButton;